export const CATEGORY_OPTIONS = [
  { value: "cat_kibble", label: "Croquettes chat" },
  { value: "cat_wet_food", label: "Pâtée chat" },
];
